import { RouteHandler } from 'wee-routes';
import { _win } from 'core/variables';
import $ from 'wee-dom';
import Flickity from 'flickity';
import $events from 'wee-events';
import 'flickity-imagesloaded';

class Hero {
    constructor() {
        const localStorageKey = 'ascendfcu.homepage.visited';
        const initialIndex = _win.localStorage.getItem(localStorageKey) === 'true'
            ? 1
            : 0;

        this.flickity = new Flickity('.js-hero', {
            autoPlay: 5000,
            imagesLoaded: true,
            wrapAround: true,
            initialIndex,
        });

        if (this.flickity.cells.length === 1) {
            $(':heroControls').css('display', 'none');
            $(':heroFocusBar').css('display', 'none');
        }

        this.flickity.on('select', () => {
            $('.js-hero__button').each((el) => {
                $(el).attr('tabindex', '-1');
            });
            $('.js-hero__button', $(this.flickity.selectedElement)).attr('tabindex', '0');
        });

        _win.localStorage.setItem(localStorageKey, 'true');
    }

    // eslint-disable-next-line class-methods-use-this
    fadeIn() {
        $(':hero').addClass('ready');
    }

    play() {
        this.toggleActiveControl();
        this.flickity.playPlayer();
    }

    pause() {
        this.toggleActiveControl();
        this.flickity.stopPlayer();
    }

    // eslint-disable-next-line class-methods-use-this
    toggleActiveControl() {
        $(':heroControls')
            .children()
            .each(el => $(el).toggleClass('-active'));
    }
}

export default new RouteHandler({
    init() {
        const hero = new Hero();

        hero.fadeIn();
        $(':playButton').addClass('-active');

        $events.on({
            ':pauseButton': {
                click() {
                    hero.pause();
                },
                keydown(e) {
                    if (e.key === 'Enter' || e.key === 'Return') {
                        hero.pause();
                    }
                },
            },
            ':playButton': {
                click() {
                    hero.play();
                },
                keydown(e) {
                    if (e.key === 'Enter' || e.key === 'Return') {
                        hero.play();
                    }
                },
            },
            '.js-hero': {
                blur: () => {
                    $(':heroFocusBar').css('max-width', '0');
                },
                focus: () => {
                    $(':heroFocusBar').css('max-width', '100%');
                },
            },
        });
    },
});
